import './tcms_default_polyfills.js';
import './tcms_core.js';
import './tcms_base_wns.js';
import './tcms_base_scrollNavi.ts';
import './tcms_base_expandList.js';
import './tcms_base_initialize.js';
import '../../../widgets/widget.global.import.js';
import './tcms_base_hooks.js';
import './login/tcms_layer.js';
import './quickchips/visits.js';

import('./tcms_base_anchorLocationJumper.ts');
import {
    onLCP, onINP, onCLS
} from 'web-vitals';

function logWebVitals({
    name, rating, value, entries
}) {
    let color;

    switch (rating) {
    case 'poor':
        color = 'red';
        break;
    case 'needs-improvement':
        color = 'orange';
        break;
    case 'good':
        color = 'green';
        break;
    default:
        color = 'white';
        break;
    }
    console.groupCollapsed(`Core Web Vitals: ${name} - rating: %c${rating} (${value})`, `color: ${color}`);
    console.table(entries);
    console.groupEnd();
}

onCLS(logWebVitals);
onINP(logWebVitals);
onLCP(logWebVitals);

/**
 * Travel navigation functionality
 */
const navElement = document.querySelector('.c24-travel-nav');
const screenWidth = window.innerWidth;

if (navElement) {
    // Mobile: Center active element in viewport
    if (screenWidth < 772) {
        const activeItem = navElement.querySelector('.c24-travel-bubble-ele.active');

        if (activeItem) {
            const scrollPosition = activeItem.offsetLeft - screenWidth / 2 + activeItem.scrollWidth / 2;

            navElement.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
            });
        }
    }

    // Overlay functionality
    const overlayBtn = document.getElementById('c24-travel-all-comparisons-btn');
    const overlay = document.getElementById('c24-travel-all-comparisons-overlay');
    const closeBtn = document.querySelector('.js-c24-travel-all-comparisons-close');
    const headerBottom = document.querySelector('.c24-travel-header-bottom');

    if (overlayBtn && overlay && headerBottom) {
        const toggleOverlay = () => {
            const isVisible = overlay.style.display !== 'none';

            if (isVisible) {
                overlay.style.display = 'none';
                overlayBtn.classList.remove('active');
            } else {
                overlay.style.display = 'block';
                overlayBtn.classList.add('active');
            }
        };

        // Toggle button click
        overlayBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleOverlay();
        });

        // Close button click
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                overlay.style.display = 'none';
                overlayBtn.classList.remove('active');
            });
        }

        // Close on outside click
        document.addEventListener('click', (e) => {
            if (overlay.style.display !== 'none' && !headerBottom.contains(e.target)) {
                overlay.style.display = 'none';
                overlayBtn.classList.remove('active');
            }
        });

        // Prevent overlay clicks from bubbling
        overlay.addEventListener('click', (e) => e.stopPropagation());
    }
}

if (
    !window.TCMS.showScrollNavigation &&
    window.TCMS.hasOwnProperty('travelCta') &&
    window.TCMS.travelCta.data.length > 0
) {
    const mainContent = document.getElementById('content');

    import('./classes/TcmsTravelCta.js').then(({ TcmsTravelCta }) => {
        if (window.TCMS.travelCta.instance === undefined) {
            window.TCMS.travelCta.instance = new TcmsTravelCta({
                travelCtaData: window.TCMS.travelCta.data,
                prependToNode: mainContent,
                useFixedPosition: true,
                eventTackingFunc: window.TCMS.trackingManager.eventTracking
            });
        }
    });
}

const modalWindowTriggerElems = document.querySelectorAll('.ck24_modal-trigger');

window.fireOnVisible(
    modalWindowTriggerElems,
    async(triggerElem) => {
        await import('./classes/TcmsModalWindow.js').then((ModalWindow) => {
            ModalWindow = ModalWindow.default;
            const modalContentId = triggerElem.dataset.modalSelector ?? '';
            const modalContent = window.TCMS?.modalWindow?.content[modalContentId] ?? '';
            const mobileSheet = triggerElem.dataset.modalMobileSheet ?? false;

            new ModalWindow(modalContent, {
                triggerElem: triggerElem,
                mobileSheet: mobileSheet
            });
        });
    },
    {
        parentContainer: document.querySelector('.c24-StationLocator_stationCounter')
    }
);

document.querySelectorAll('[data-accordion="true"]').forEach(function(accordionTriggerNode) {
    window.fireOnVisible(accordionTriggerNode, async() => {
        await import('./tcms_base_accordion.js').then(async(Accordion) => {
            await import('../styles/ck24_accordion.scss').then(function() {
                Accordion = Accordion.default;
                const accordion = new Accordion(accordionTriggerNode, {
                    isMobile: window.isMobileDetected
                });

                accordion.addToggleEventListener(accordionTriggerNode);
            });
        });
    });
});
